// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import ratios from 'Components/utils/ratios/ratios.utils';
import Image from 'Components/frameworks/image/Image.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Title } from 'Components/frameworks/title/Title.jsx';

type ProductImageMapLineProps = {
  mapMobileDimensions?: {
    w: number,
    h: number,
  },
  mapTabletRatio?: MediaRatios,
  resort?: { name: string, mapUrl?: string },
  title?: string,
};

export const ProductImageMapLine = ({
  mapMobileDimensions = {
    w: 600,
    h: 500,
  },
  mapTabletRatio = ratios.S,
  resort = {},
  title,
}: ProductImageMapLineProps) => {
  const { isTablet } = useContext(ResponsiveContext);
  const { name: altMsg, mapUrl: imageUrl } = resort;
  if (!imageUrl) return null;
  const map = { altMsg, imageUrl };
  const mapConf = isTablet
    ? {
        ratioKey: mapTabletRatio,
        transformation: 'resize',
      }
    : {
        mandatoryWidthAndHeight: mapMobileDimensions,
      };
  return (
    <SiteContainer className="Line Line-ProductImageMap">
      <Title className="mb-8" theme="title-sans-4">
        {title}
      </Title>
      <Image {...map} {...mapConf} />
    </SiteContainer>
  );
};
